export enum AssetCodeHeight {
  S = 8.5,
  M = 9.5,
}
